import {AxiosInstance} from 'axios';

import {
  AUTHORIZATION,
  BEARER,
  HTTP_STATUS,
  X_CHECKOUT_ID,
  X_CUSTOMER_ID,
  X_MERCHANT_ID,
  X_UPSTREAM_ENV,
} from '../utils/constants';

export const createDefaultHeader = ({
  merchantId,
  customerId,
  checkoutSessionId,
  hcpToken,
  upstreamEnv,
}: {
  merchantId: string;
  customerId: string;
  checkoutSessionId: string;
  hcpToken: string;
  upstreamEnv: string;
}) => {
  return {
    [AUTHORIZATION]: `${BEARER} ${hcpToken}`,
    [X_MERCHANT_ID]: merchantId,
    [X_CHECKOUT_ID]: checkoutSessionId,
    [X_CUSTOMER_ID]: customerId,
    [X_UPSTREAM_ENV]: upstreamEnv,
  };
};

let localHeaders: {[key: string]: string} = {};
export const setHeaders = (headers: {[key: string]: string}) => {
  localHeaders = headers;
};
export const getHeaders = () => localHeaders;

export const authInterceptor = (axios: AxiosInstance, callback: () => void) => {
  axios.interceptors.response.use(
    (response) => {
      return response;
    },
    async (error) => {
      if (HTTP_STATUS.UNAUTHORIZED === error?.response?.status) {
        callback();
        return Promise.reject(error);
      } else {
        return Promise.reject(error);
      }
    }
  );
};

export type HttpServiceError = {
  message: string;
};

export const errorInterceptor = (axios: AxiosInstance, callback: (args: HttpServiceError) => void) => {
  axios.interceptors.response.use(
    (response) => {
      return response;
    },
    async (error) => {
      const response = error?.response;
      if (
        response.status !== HTTP_STATUS.UNAUTHORIZED &&
        response.status >= HTTP_STATUS.BAD_REQUEST &&
        response.status <= HTTP_STATUS.NETWORK_CONNECT_TIMEOUT_ERROR
      ) {
        callback({
          message: response?.data?.detail || 'Something went wrong. Please close and try again.',
        });
      }
      return Promise.reject(error);
    }
  );
};
